import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScheduledActingAssignment } from "src/app/store/application";

@Injectable()
export class ActingService {
    apiUrl = 'api/scheduledacting';

    httpOptions = {
        headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })
    };

    constructor(private httpClient: HttpClient) { }

    getAllScheduledActingAssignments(): Observable<ScheduledActingAssignment[]> {
        return this.httpClient.get<ScheduledActingAssignment[]>(`${this.apiUrl}/GetAllActingAssignments`, this.httpOptions);
    }

    getUserRelatedActingAssignments(): Observable<ScheduledActingAssignment[]> {
        return this.httpClient.get<ScheduledActingAssignment[]>(`${this.apiUrl}/GetUserRelatedActingAssignments`, this.httpOptions);
    }

    getUserScheduledActingAssignments(): Observable<ScheduledActingAssignment[]> {
        return this.httpClient.get<ScheduledActingAssignment[]>(this.apiUrl, this.httpOptions);
    }

    addScheduledActingAssignment(scheduledActing: ScheduledActingAssignment): Observable<any> {
        return this.httpClient.post(this.apiUrl, scheduledActing, this.httpOptions);
    }

    updateScheduledActingAssignment(scheduledActing: ScheduledActingAssignment): Observable<any> {
        return this.httpClient.put(this.apiUrl, scheduledActing, this.httpOptions);
    }

    deleteScheduledActingAssignment(id: number): Observable<any> {
        return this.httpClient.delete(`${this.apiUrl}/${id}`, this.httpOptions);
    }
}